export default class BookSnapshotItem {
  constructor(qtyBid, pxBid, pxOffer, qtyOffer, bidSubType, offerSubType) {
    this.qtyBid = qtyBid;
    this.pxBid = pxBid;
    this.pxOffer = pxOffer;
    this.qtyOffer = qtyOffer;
    this.bidSubType = bidSubType;
    this.offerSubType = offerSubType;
  }
}